import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  orders: {
      page: 1,
      total: 0,
      pageSize: 25,
      result: []
  },
  userdata: null
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};